// Module
var code = "<div class=\"full-height\"> <fulfillment-view fulfillment=\"$ctrl.fulfillment\" on-dispatch=\"$ctrl.onDispatch($ctrl.fulfillment, stepIds, $event)\" on-reload-steps=\"$ctrl.getFulfilment(fulfillmentId)\"> </fulfillment-view> </div> ";
// Exports
export default code;